/// <amd-module name="Build/Common/Artifacts/providers/Filepath" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes } from 'Common';
export class FilePath extends Base {
    public getKey() {
        return BuildArtifactTypes.FilePath;
    }

    public supportsDownload(): boolean {
        return true;
    }

    public supportsExploring(): boolean {
        return false;
    }

    public onDownload() {
        this.showCopyDialog();
    }
}
